/**
 * External dependencies
 */
import { omit } from 'lodash';
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import { START_EDITING_LOCATION_WEBSITE } from 'state/action-types';

import { createReducer } from 'state/utils';

export const locationWebsiteId = createReducer(null, {
    [START_EDITING_LOCATION_WEBSITE]: (state, { payload }) => payload.locationWebsiteId,
});

export default combineReducers({
    locationWebsiteId,
});
